import { createAction, ActionsUnion } from "../definitions";
import { TripActionTypes } from "./types";
import Trip from "../../model/Trip";
import { getStartOfDayUserTimezone } from "../../utils/date";
import { getServerDate } from "../../utils/storage/date";

export interface ITripPayload {
    userId: string;
    trips: IIdDictionary<Trip>;
    /** Start of the user's day (ISO), added by setTrips for the tripsTodayCount reducer, which cannot read the clock. */
    startOfDay?: string;
}

/**
 * Computes the target driver's local day boundary for the derived Dashboard count. Callers provide the
 * target driver's timezone so an action never reads the active viewer's mutable DST calculator context.
 */
export function getTripStartOfDay(timeZoneId: string | undefined): string | undefined {
    if (!timeZoneId) {
        return undefined;
    }
    try {
        return getStartOfDayUserTimezone(getServerDate(), timeZoneId).toISOString();
    } catch {
        return undefined;
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TripActions = {
    clearTrips: (userId?: string) => createAction(TripActionTypes.CLEAR_TRIPS, userId),
    setTrips: (payload: ITripPayload) => createAction(TripActionTypes.SET_TRIPS, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TripActions = ActionsUnion<typeof TripActions>;